import { render, staticRenderFns } from "./summary.vue?vue&type=template&id=2849f8e1&"
import script from "./summary.vue?vue&type=script&lang=js&"
export * from "./summary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("c:\\xampp\\htdocs\\app.poojalab.com\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2849f8e1')) {
      api.createRecord('2849f8e1', component.options)
    } else {
      api.reload('2849f8e1', component.options)
    }
    module.hot.accept("./summary.vue?vue&type=template&id=2849f8e1&", function () {
      api.rerender('2849f8e1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/user/summary.vue"
export default component.exports